import { useState } from 'react';

function Header() {
  // State for mobile menu toggle
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // State for dark mode toggle
  const [darkMode, setDarkMode] = useState(false);

  // Toggle dark mode on html element
  const toggleDarkMode = () => {
    document.documentElement.classList.toggle('dark');
    setDarkMode(!darkMode);
  };

  return (
    <header className="sticky top-0 z-50 bg-white/80 dark:bg-background-dark/80 backdrop-blur-md border-b border-solid border-[#f0f4f0] dark:border-gray-800">
      <div className="max-w-[1200px] mx-auto px-6 h-20 flex items-center justify-between">

        {/* Logo */}
        <div className="flex items-center gap-3">
          <h2 className="text-[#111811] dark:text-white text-xl font-bold leading-tight tracking-tight">
            Motif Farms & Agro Processing
          </h2>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <a className="text-sm font-medium hover:text-primary transition-colors" href="#about">About</a>
          <a className="text-sm font-medium hover:text-primary transition-colors" href="#products">Products</a>
          <a className="text-sm font-medium hover:text-primary transition-colors" href="#gallery">Gallery</a>
          <a className="text-sm font-medium hover:text-primary transition-colors" href="#order">Contact</a>
        </nav>

        {/* Right Side - Dark Mode & CTA */}
        <div className="flex items-center gap-4">


          {/* Order Now Button - Hidden on mobile */}
          <a
            className="hidden sm:block bg-primary hover:bg-primary-light text-white px-6 py-2.5 rounded-lg text-sm font-bold tracking-wide transition-all shadow-sm"
            href="#order"
          >
            Order Now
          </a>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className="material-symbols-outlined">
              {mobileMenuOpen ? 'close' : 'menu'}
            </span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white dark:bg-background-dark border-t border-gray-100 dark:border-gray-800 px-6 py-4">
          <nav className="flex flex-col gap-4">
            <a
              className="text-sm font-medium hover:text-primary transition-colors py-2"
              href="#about"
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </a>
            <a
              className="text-sm font-medium hover:text-primary transition-colors py-2"
              href="#products"
              onClick={() => setMobileMenuOpen(false)}
            >
              Products
            </a>
            <a
              className="text-sm font-medium hover:text-primary transition-colors py-2"
              href="#gallery"
              onClick={() => setMobileMenuOpen(false)}
            >
              Gallery
            </a>
            <a
              className="text-sm font-medium hover:text-primary transition-colors py-2"
              href="#order"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact
            </a>
            <a
              className="bg-primary hover:bg-primary-light text-white px-6 py-3 rounded-lg text-sm font-bold text-center transition-all"
              href="#order"
              onClick={() => setMobileMenuOpen(false)}
            >
              Order Now
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;